// Tenantra Inc. - Admin invite acceptance: new staff set their own password.
import { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, ShieldCheck } from 'lucide-react';
import api, { apiHelpers } from '@/services/api';

export default function AcceptStaffInvitePage() {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error('This link is missing its invitation token'); return; }
    if (password.length < 8) { toast.error('Use at least 8 characters'); return; }
    if (password !== confirm) { toast.error('Passwords do not match'); return; }
    setBusy(true);
    try {
      await api.post('/admin/staff/accept', { token, password });
      setDone(true);
      toast.success('Password set ✓');
      setTimeout(() => { window.location.href = '/portal-8k2m9x/login'; }, 1500);
    } catch (e2) { toast.error(apiHelpers.handleError(e2)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-950 px-4">
      <div className="w-full max-w-sm bg-white rounded-2xl p-7 shadow-xl" data-testid="accept-invite-card">
        <div className="flex items-center gap-2 mb-1"><ShieldCheck className="w-5 h-5 text-teal-600" /><span className="font-semibold text-slate-900">Tenantra Admin</span></div>
        <h1 className="text-lg font-semibold text-slate-900 mb-1">Set your password</h1>
        <p className="text-sm text-slate-500 mb-5">Create a password to access the admin portal.</p>
        {done ? (
          <p className="text-sm text-emerald-700" data-testid="accept-invite-done">All set — taking you to sign in…</p>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" autoComplete="new-password" className="w-full h-10 px-3 rounded-lg border border-slate-200 text-sm focus:ring-2 focus:ring-teal-500 outline-none" data-testid="accept-invite-password" />
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm password" autoComplete="new-password" className="w-full h-10 px-3 rounded-lg border border-slate-200 text-sm focus:ring-2 focus:ring-teal-500 outline-none" data-testid="accept-invite-confirm" />
            <button disabled={busy} className="w-full h-10 rounded-lg bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium inline-flex items-center justify-center gap-2" data-testid="accept-invite-submit">{busy && <Loader2 className="w-4 h-4 animate-spin" />}Set password & continue</button>
          </form>
        )}
      </div>
    </div>
  );
}
